import React, { useState, useMemo, useEffect } from 'react';
import { MenuItem } from '@material-ui/core';
import Slider from 'react-slick';

import styles, { CategorySelect, PaginationWrapper } from './styles';
import { POD_CATEGORIES, getPODCategoryLabel } from '../../constants/pod';
import AxlDialog from '../../components/AxlDialog';

// Menu order is also the priority order for the modal's default category.
const POD_CATEGORY_ORDER = Object.values(POD_CATEGORIES);

const filterPODImages = (images = [], category) => images.filter((img) => img?.category === category);

const getDefaultPODCategory = (images = []) =>
  POD_CATEGORY_ORDER.find((category) => filterPODImages(images, category).length > 0) || POD_CATEGORY_ORDER[0];

const ShipmentPODModal = ({
  open,
  onClose,
  stop_images,
  selectedStop,
}) => {
  const [category, setCategory] = useState(() => getDefaultPODCategory(stop_images));
  const [currentIndex, setCurrentIndex] = useState(0);
  const filteredImages = useMemo(() => filterPODImages(stop_images, category), [stop_images, category]);
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SliderNextArrow />,
    prevArrow: <SliderPrevArrow />,
    beforeChange: (currentSlide, nextSlide) => setCurrentIndex(nextSlide),
  };

  useEffect(() => {
    if (open) {
      setCategory(getDefaultPODCategory(stop_images));
      setCurrentIndex(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const onChangeCategory = (e) => {
    setCategory(e.target.value);
    setCurrentIndex(0);
  };

  const DropdownHeader = () => {
    return (
      <div>
        Category:{' '}
        <CategorySelect variant="standard" value={category} onChange={onChangeCategory}>
          {POD_CATEGORY_ORDER.map((value) => (
            <MenuItem key={value} value={value}>
              {getPODCategoryLabel(value, selectedStop)}
            </MenuItem>
          ))}
        </CategorySelect>
      </div>
    )
  }

  return (
    <AxlDialog
      isOpen={open}
      handleClose={onClose}
      maxWidth="sm"
      childrenTitle={<DropdownHeader />}
      DialogContentProps={{
        style: {
          padding: '0',
        },
      }}

    >
      {filteredImages.length > 0 ? (
        <div>
          {/* Remounting on category change resets the slider to the first image. */}
          <Slider key={category} {...settings}>
            {filteredImages.map((img) => (
              <div key={img.id}>
                <div style={styles.slideContainer}>
                  <div style={styles.imageWrapper}>
                  <img
                    src={img.url}
                    alt={`Proof of ${getPODCategoryLabel(category, selectedStop)}`}
                    style={styles.imageStyle}
                    />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          <PaginationWrapper data-testid="shipment-pod-image-pagination">
            {currentIndex + 1} / {filteredImages.length}
          </PaginationWrapper>
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '20px', minHeight: '80vh' }}>No images found</div>
      )}
    </AxlDialog>
  );
};

function SliderPrevArrow(props) {
  const { onClick } = props;
  return (
    <div style={{ ...styles.arrowButton, ...styles.arrowPrev }} onClick={onClick}>
      <i style={styles.arrowIcon} className="fa fa-angle-left" />
    </div>
  );
}

function SliderNextArrow(props) {
  const { onClick } = props;
  return (
    <div style={{ ...styles.arrowButton, ...styles.arrowNext }} onClick={onClick}>
      <i style={styles.arrowIcon} className="fa fa-angle-right" />
    </div>
  );
}

export default ShipmentPODModal;
